module.exports = __webpack_public_path__ + "img/thumb_26.9cd4ac31.jpg";